// extracted by mini-css-extract-plugin
module.exports = {"prevBtn":"Pagination_prevBtn__vAIru","nextBtn":"Pagination_nextBtn__1wpro","paginationItem":"Pagination_paginationItem__PU1Qg"};